import {useLocation} from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import {useEffect} from "react";
import PdfReportViewer from "./PdfReportViewer";
import {AUTH_COOKIE} from "@/constants";
import Cookies from "js-cookie";

export default function PdfReport(){
        const { search } = useLocation();
        const parameters = new URLSearchParams(search);
        const project_id = parameters.get("project_id");
        const type = parameters.get("type");
        const ads = parameters.get("ads") == "true" || false;
        const sold = parameters.get("sold" )== "true" || false;
        const market = parameters.get("market") == "true" || false;
        const priceDevelopment = parameters.get("price_development") == "true" || false;
        const comment = parameters.get("comment");
        const access_token = parameters.get("access_token") || "";
        const selected_columns_sold = parameters.get("selected_columns_sold");
        const selected_columns_ads = parameters.get("selected_columns_ads");
        const show_ref_price = parameters.get("show_ref_price") == "true" || false;
        const market_zoom = parseInt(parameters.get("market_zoom") as string) || 4;
        const limit = parseInt(parameters.get("limit") as string) || 15;
       const props = {project_id, show_ref_price, market_zoom, type, ads, sold, market, priceDevelopment, comment, selected_columns_sold, selected_columns_ads, limit};

        const { setAuthToken, authToken } = useAuth();
        useEffect(() => {
          setAuthToken(access_token);
          const expires = new Date(new Date().getTime() + 100 * 10000);
          Cookies.set(AUTH_COOKIE, access_token, {
            expires: expires,
            secure: true,
            sameSite: 'Strict',
          });
        },[]);

        return !!authToken && <PdfReportViewer props={props} />
}